import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ProbeProposedComponent } from './components/probe-proposed/probe-proposed.component';
import { ValueBuildsComponent } from './components/value-builds/value-builds.component';
import { ValueBuildCombinationsComponent } from './components/value-build-combinations/value-build-combinations.component';
import { MetaboliteConfirmedComponent } from './components/metabolite-confirmed/metabolite-confirmed.component';
import { DegradationPathwayComponent } from './components/degradation-pathway/degradation-pathway.component';
import { GlpStudySpecificsComponent } from './components/glp-study-specifics/glp-study-specifics.component';
import { GlpStudySpecificsSearchComponent } from './components/glp-study-specifics/glp-study-specifics-search/glp-study-specifics-search.component';
import { GlpStudySpecificsToxicologyComponent } from './components/glp-study-specifics/glp-study-specifics-toxicology/glp-study-specifics-toxicology.component';
import { GlpStudySpecificsResiduesComponent } from './components/glp-study-specifics/glp-study-specifics-residues/glp-study-specifics-residues.component';
import { MetaboliteSummaryComponent } from './components/metabolite-summary/metabolite-summary.component';
import { StructureImageComponent } from './components/structure-image/structure-image.component';
import { MsalGuard } from "@azure/msal-angular";
import { BrowserUtils } from '@azure/msal-browser';
import { ResidueDefinitionComponent } from './components/residue-definition/residue-definition.component';
import { AccessControlComponent } from './components/access-control/access-control.component'
import { UnauthorizedComponent } from './shared/unauthorized/unauthorized.component';


const routes: Routes = [
  { path: 'home', component: HomeComponent, canActivate: [MsalGuard] },
  { path: 'probeProposed', component: ProbeProposedComponent, canActivate: [MsalGuard] },
  { path: 'confirmed', component: MetaboliteConfirmedComponent, canActivate: [MsalGuard] },
  { path: 'administrator/valueBuilds', component: ValueBuildsComponent, canActivate: [MsalGuard] },
  { path: 'administrator/valueBuildCombinations', component: ValueBuildCombinationsComponent, canActivate: [MsalGuard] },
  { path: 'DegradationPathway', component: DegradationPathwayComponent, canActivate: [MsalGuard] },
  { path: 'physicalChemical', component: GlpStudySpecificsComponent, canActivate: [MsalGuard] },
  { path: 'analyticalMethods', component: GlpStudySpecificsComponent, canActivate: [MsalGuard] },
  { path: 'toxicology', component: GlpStudySpecificsToxicologyComponent, canActivate: [MsalGuard] },
  { path: 'metabolism', component: GlpStudySpecificsComponent, canActivate: [MsalGuard] },
  { path: 'residues', component: GlpStudySpecificsResiduesComponent, canActivate: [MsalGuard] },
  { path: 'enviromentFate', component: GlpStudySpecificsComponent, canActivate: [MsalGuard] },
  { path: 'allSections', component: GlpStudySpecificsSearchComponent, canActivate: [MsalGuard] },
  { path: 'metaboliteSummary', component: MetaboliteSummaryComponent, canActivate: [MsalGuard] },
  { path: 'residueDefinition', component: ResidueDefinitionComponent, canActivate: [MsalGuard] },
  { path: 'administrator/accessControl', component: AccessControlComponent, canActivate: [MsalGuard] },
  { path: 'postlogin', redirectTo: '/home' },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', redirectTo: '/home', pathMatch: 'full' }
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule {


 }
